export default __webpack_public_path__ + "static/ecosystem-1af1150b8b5e0d007a800cc9cf326365.jpg";